export default __webpack_public_path__ + "static/slogan-0cdc40c074faf8be64f5ba368e4dcf65.png";